import { addDays } from '@pst/core-scheduling';

/**
 * What a drag on a bar means, as a pure function.
 *
 * Moving a bar pins its start; pulling its right end sets a finish, which the
 * server turns into a duration. These are exactly the edits the date cells in
 * the list send, so a dragged bar and a typed date can never mean two different
 * things.
 */
export type DragEdit = { startDate: string } | { finishDate: string };

export interface DragGesture {
  mode: 'move' | 'resize';
  originStart: string;
  originFinish: string;
  /** Calendar days the pointer has travelled; negative means to the left. */
  offset: number;
}

/** Null when the gesture changes nothing and should simply be dropped. */
export function dragEdit(gesture: DragGesture): DragEdit | null {
  if (gesture.offset === 0) return null;

  if (gesture.mode === 'move') {
    return { startDate: addDays(gesture.originStart, gesture.offset) };
  }

  const finish = addDays(gesture.originFinish, gesture.offset);
  // A bar cannot be pulled shorter than its first day; that gesture is void
  // rather than turned into something the user did not ask for.
  return finish >= gesture.originStart ? { finishDate: finish } : null;
}

/** Calendar days for a pointer distance, snapped to whole days. */
export function daysForDistance(pixels: number, dayWidth: number): number {
  return Math.round(pixels / dayWidth);
}
